import React from 'react';

const StatusAndAPNSetting = ({ t, unit, unitsettingsHandler }) => {
  return (
    <div className='status-connection'>
      <span className='statusTxt'>
        {unit.status === 'streaming' ? (
          <span className='onlineTxt'>{t('STREAMINGSTATUS')}</span>
        ) : unit.status === 'connected' ? (
          <span className='onlineTxt'>{t('ONLINESTATUS')}</span>
        ) : (
          <span className='offlineTxt'>{t('OFFLINESTATUS')}</span>
        )}
      </span>
      <span className='apnSettings'>
        <span
          className='btn btn-primary btn-sm'
          onClick={() => unitsettingsHandler(unit)}
        >
          {t('APNSETTINGS')}
        </span>
      </span>
    </div>
  );
};

export default StatusAndAPNSetting;
